function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "FB.svg",
  d: "M22.001 1.376v19.25a1.38 1.38 0 01-1.377 1.375h-5.646v-9.009h2.9l1.116-2.987h-4V8.048c0-1.373 1.083-2.061 2.458-2.061h1.555V2.993h-2.88c-2.521 0-4.124 1.981-4.124 4.813v2.189H8.995v3h3.012v9.009H1.377a1.377 1.377 0 01-1.374-1.375V1.379A1.378 1.378 0 011.377.003h19.249a1.381 1.381 0 011.375 1.373z",
  fill: "#2C2F45"
});

var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.001,
    height: 22
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi4wMDEiIGhlaWdodD0iMjIiPjxwYXRoIGRhdGEtbmFtZT0iRkIuc3ZnIiBkPSJNMjIuMDAxIDEuMzc2djE5LjI1YTEuMzggMS4zOCAwIDAxLTEuMzc3IDEuMzc1aC01LjY0NnYtOS4wMDloMi45bDEuMTE2LTIuOTg3aC00VjguMDQ4YzAtMS4zNzMgMS4wODMtMi4wNjEgMi40NTgtMi4wNjFoMS41NTVWMi45OTNoLTIuODhjLTIuNTIxIDAtNC4xMjQgMS45ODEtNC4xMjQgNC44MTN2Mi4xODlIOC45OTV2M2gzLjAxMnY5LjAwOUgxLjM3N2ExLjM3NyAxLjM3NyAwIDAxLTEuMzc0LTEuMzc1VjEuMzc5QTEuMzc4IDEuMzc4IDAgMDExLjM3Ny4wMDNoMTkuMjQ5YTEuMzgxIDEuMzgxIDAgMDExLjM3NSAxLjM3M3oiIGZpbGw9IiMyQzJGNDUiLz48L3N2Zz4=";
export { SvgIconFacebook as ReactComponent };